import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  useGetCourtReservationsHistoryQuery,
  useGetOrganizerReservationsQuery,
} from '../../Api/reservations';
import { useGetUnavailablePeriodsQuery } from '../../Api/unavailability';
import { useGlobalState } from '../../App/globalState';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import HistoryDisplay from './historyDisplay';
import PeriodsDisplay from './periodsDisplay';
import ReservationsDisplay from './reservationsDisplay';
import SetUnavailableModal from './setUnavailableModal';
import OrganizerReservationsWrapper from './style/organizerReservationsWrapper';

const OrganizerReservations = () => {
  const { globalState } = useGlobalState();
  const { language } = globalState || {};
  const tr = useTranslate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInputs, setModalInputs] = useState({
    dateFrom: null,
    dateUntil: null,
    timeFrom: '',
    timeUntil: '',
  });

  const { courtId } = useParams();
  const { data: unavailablePeriods } = useGetUnavailablePeriodsQuery({
    params: { courtId },
  });

  const { data: organizerReservations } = useGetOrganizerReservationsQuery({
    params: { courtId },
  });

  const { data: reservationsHistory } = useGetCourtReservationsHistoryQuery({
    params: { courtId },
  });

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <OrganizerReservationsWrapper>
      <div className='display-container'>
        <ReservationsDisplay data={organizerReservations} />
        <div className='history-and-periods-container'>
          <PeriodsDisplay
            data={unavailablePeriods}
            courtId={courtId}
            language={language}
          />
          <HistoryDisplay data={reservationsHistory} language={language} />
        </div>
      </div>

      <div className='button-container'>
        <Button onClick={openModal}>{tr('set_unavailable')}</Button>
      </div>
      <SetUnavailableModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        modalInputs={modalInputs}
        setModalInputs={setModalInputs}
        courtId={courtId}
      />
    </OrganizerReservationsWrapper>
  );
};

export default OrganizerReservations;
